<template lang="html">
  <div id="paypal-button"/>
</template>

<script>
export default {
  props: {
    amount: {
      type: [String, Number],
    },
    payable: {
      type: Boolean,
      default: true
    },
    description: {
      type: String,
      default: 'Profile  Create/Upgrade'
    },
    uniqueSlug: {
      type: String,
      required: true
    },
    profileId: {
      type: String,
      required: true
    },
    promocode: {
      type: String,
      default: ''
    },
    discountAmount: {
      type: [String, Number],
      default: ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      const vue = this

paypal.Buttons(
        {
          createOrder: async (data, actions) => {
                  if(vue.payable) {
                    vue.$emit('paying', false)
                    await vue.$store.dispatch('paymentStore/initializePayment', { 
                      uniqueSlug: vue.uniqueSlug,
                      profileId: vue.profileId
                    })
                    return actions.order.create({
                        purchase_units: [{
                            amount: {
                              value: vue.amount,
                                details: {
                                'discount': `${vue.promocode ? vue.discountAmount: ''}`,
                              },
                            },
                            description: `${vue.description} <p style="font-weight: bold" >${vue.promocode ?  
                                        `Promo Code Used: ${vue.promocode}`.bold() : '' }</p>`,
                        }],
                        application_context: {
                         shipping_preference: 'NO_SHIPPING'
                       },
                    });
                  } else {
                    vue.$emit("handle-unpayable")
                  }
               },
               // Finalize the transaction
           onApprove: (data, actions) => {
               return actions.order.capture().then( (details) => {
                   // Show a success message to the buyer
                   vue.$emit('transaction-completed', details)
                   vue.$emit('paying', false)
                   // alert('Transaction completed by ' + details.payer.name.given_name + '!');
               });
           },
           onCancel: (data, actions) => {
              vue.$emit('paying', false)
           }
        }
      ).render('#paypal-button')
    })
  }
}
</script>

<style lang="css" scoped>
</style>
